import { ClientAppEntry, clientAppRouteName } from '@/apps/clientAppRegistry'

export const VIEW_ID = 'brelag-user'

export const CLIENT_APP: ClientAppEntry = {
  name: 'Brelag User',
  path: 'brelag-user',
  icon: 'mdi-hexagon-multiple',
  defaultPathName: 'project-list',
}

export function brelagUserRouteName(routeName: string) {
  return clientAppRouteName(VIEW_ID, routeName)
}
